import JobViewModel from '../JobViewModel'
import { observer } from 'mobx-react'
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from '../../../../../components/Card'
import { SectionLoading, SectionError } from '../Section/Section'
import React from 'react'
import Button from '../../../../../components/Button'
import CompleteInfoGatheringDialogModal from './CompleteInfoGatheringDialogModal'

interface Props {
  vm: JobViewModel
}

export default observer(function InfoGatheringCard({ vm }: Props) {
  return (
    <>
      <Card>
        {vm.activate.match({
          pending: () => <SectionLoading />,
          rejected: (err) => (
            <SectionError
              title="An error occurred while loading the info gathering checklist."
              error={err}
            />
          ),
          resolved: () => (
            <>
              <CardHeader>
                <CardTitle>
                  {vm.consultationIsPendingScheduling
                    ? 'Awaiting for customer availability'
                    : 'Gather Supporting Items'}
                </CardTitle>
              </CardHeader>
              <CardContent>
                {vm.infoGatheringCardVM.isAdmin ? (
                  <>
                    {vm.consultationIsPendingScheduling
                      ? vm.consultationPendingSchedulingText
                      : 'Awaiting supporting items from the client. To proceed, complete on their behalf'}
                  </>
                ) : vm.infoGatheringCardVM.isClient ? (
                  <>
                    Awaiting supporting items. To proceed, please provide the
                    requested items found in the checklist.
                  </>
                ) : (
                  <>Awaiting supporting items from the client.</>
                )}
              </CardContent>
              <CardContent
                compactBottomPadding={vm.consultationIsPendingScheduling}
              >
                {!vm.consultationIsPendingScheduling && (
                  <Button
                    type="primary"
                    size="wide-slim"
                    data-test="info-gathering-card-complete-button"
                    onClick={() =>
                      vm.infoGatheringCardVM.completeStepConfirmDialog.show()
                    }
                    disabled={!vm.infoGatheringCardVM.canCompleteInfoGathering}
                  >
                    Complete Info Gathering
                  </Button>
                )}
              </CardContent>
            </>
          ),
        })}
      </Card>
      <CompleteInfoGatheringDialogModal vm={vm.infoGatheringCardVM} />
    </>
  )
})
